// extracted by mini-css-extract-plugin
export default {"container":"bv_d","containerHidden":"bv_gt","imageWrapper":"bv_gv","title":"bv_c0","buttonWrapper":"bv_gw","button":"bv_dS"};